import { TableColumn } from "react-data-table-component";
import { TopicPart } from "../../../../core/topicPart/entities/TopicPart";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { TranslationFunction } from "../../../../utils/utils";
import { boolBadgeClasses } from "../../../constants/badgeClasses";

const topicPartTableConfig = (
  t: TranslationFunction,
  topicPartPath: (id: string | number) => string
): TableColumn<TopicPart>[] => [
  {
    name: "topicPart.field.rank",
    selector: (row: TopicPart) => row.rank ?? "",
    width: "60px",
  },
  {
    name: "topicPart.field.title",
    selector: (row: TopicPart) => row.title,
    style: {
      minWidth: "300px",
    },
  },
  {
    name: "topicPart.field.description",
    selector: (row: TopicPart) => row.description ?? "",
    width: "300px",
  },
  {
    name: "topicPart.field.duration",
    selector: (row: TopicPart) => row.timing ?? "",
    width: "120px",
  },
  {
    name: "topicPart.field.answerTogether",
    selector: (row: TopicPart) =>
      t(row.answerTogether ? "common.yes" : "common.no"),
    width: "100px",
    cell: (row: TopicPart) => {
      return (
        <span className={boolBadgeClasses(row.answerTogether)}>
          {row.answerTogether ? t("common.yes") : t("common.no")}
        </span>
      );
    },
  },
  {
    name: "topicPart.field.isSynthesisPart",
    selector: (row: TopicPart) =>
      t(row.isSynthesisPart ? "common.yes" : "common.no"),
    width: "100px",
    cell: (row: TopicPart) => {
      return row.isSynthesisPart ? (
        <span className={boolBadgeClasses(true)}>{t("common.yes")}</span>
      ) : null;
    },
  },
  {
    name: "",
    width: "50px",
    cell: (row: TopicPart) => (
      <Link
        to={topicPartPath(row.id)}
        onClick={(e) => e.stopPropagation()}
        className="inline-flex text-inherit"
      >
        <ExternalLink className="w-4 h-4" />
      </Link>
    ),
  },
];

export default topicPartTableConfig;
